import styled from '@emotion/styled'

import { spacingSection } from '@/styles/mixins'

interface SectionPlaceholderProps {
  height?: string
  testId?: string
  children?: React.ReactNode
}

const Container = styled.div<{ height: string }>`
  ${spacingSection};
  min-height: ${props => props.height};
  height: ${props => props.height};
  contain: layout;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.6;
`

function SectionPlaceholder({
  height = '400px',
  testId,
  children
}: SectionPlaceholderProps) {
  return (
    <Container height={height} data-test-id={testId}>
      {children}
    </Container>
  )
}

export default SectionPlaceholder
